import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import styled from 'styled-components'
import GenericModal from '../../GenericModal'
import employeeService from '../../../services/Employee.service'

const Content = styled.div`
  padding: 15px 20px 20px 20px;

  > div {
    font-family: Lato-Regular;
    font-size: 14px;
    text-align: justify;
    line-height: 22px;
    color: #2B2B2B;
    margin: 0px;
    margin-bottom: 0px;
  }
`

class AnnualReportProxyStatementDialog extends Component {

  render() {
    const { t, employee } = this.props;
    const dialogText = employeeService.isWholeFoodsEmployee(employee) || employeeService.isZooxEmployee(employee) ? t('AnnualReportProxyStatementDialog.TextWholeFoods') : t('AnnualReportProxyStatementDialog.Text')

    return (
      <GenericModal
        title={t('PopularActions.WantToSeeButton')}
        visible={this.props.visible}
        onCloseDialog={this.props.onCloseDialog}
        width={560}
        className="annual-report-dialog"
      >
        <Content>
          <div>
            <p dangerouslySetInnerHTML={{ __html: dialogText }}>
            </p>
          </div>
        </Content>
      </GenericModal>
    )
  }
}

const mapState = state => (
  {
    configuration: state.configuration,
    employee: state.employee
  }
)

export default connect(mapState, null)((withTranslation('translations')(AnnualReportProxyStatementDialog)))